import { formatMoney } from "@/components/restaurant/finance/constants";

const RATE_SUFFIX = { 1: "/mj", 2: "%", 3: "/obrok", 4: "" };

/**
 * Nazivi redova knjige (tip unosa) i stopa provizije za kartice transakcija i panel narudžbe.
 * Tip bez prevoda se prikazuje kao tekst koda ("loss compensation"), nikad kao sirov ključ.
 */
export default {
  methods: {
    /** "Provizija 20 %" ili "Provizija 0,50/obrok" */
    rateText(line) {
      if (line.rateValue === null || line.rateValue === undefined) {
        return "";
      }
      return Number(line.rateType) === 2 ? `${line.rateValue} %` : `${formatMoney(line.rateValue, "")}${RATE_SUFFIX[line.rateType] || ""}`;
    },
    lineLabel(line) {
      const type = line.entryType;
      if (/REFUND/.test(type)) {
        return this.$t("finance_event_refund");
      }
      const key = `finance_shell.types.${type}`;
      const label = this.$te(key) ? this.$t(key) : String(type || "").toLowerCase().replace(/_/g, " ");
      return type === "COMMISSION" && this.rateText(line) ? `${label} ${this.rateText(line)}` : label;
    },
  },
};
